"use client";

import { useEffect } from "react";

export function CookieSize() {
  useEffect(() => {
    // Most browsers cookies size limit is close to 4000 bytes
    // Validate that the cookie weight is not close to exceeding that limit
    const cookiesString = document.cookie;
    const maxCookiesLength = 3200;
    if (cookiesString.length > maxCookiesLength) {
      const cookies = cookiesString.split("; ");
      const maxCookieLength = Math.floor(maxCookiesLength / cookies.length);
      //the cookies for gemini are set under gemini.com - without the subdomain
      const hostname =
        window.location.hostname === "www.gemini.com"
          ? "gemini.com"
          : window.location.hostname;
      cookies.forEach((cookie) => {
        if (cookie.length > maxCookieLength)
          document.cookie = `${cookie.substring(0, maxCookieLength)}; domain=.${hostname}`;
      });
    }
  }, []);

  return null;
}
